@if (appEnvironment !== AppEnvironmentEnum.LIVE) {
	<div class="diagonal-banner"
		 [ngClass]="appEnvironment">
		<span>{{ appEnvironment }}</span>
	</div>
}